module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('van-popup', {
    style: ({
      height: '60%'
    }),
    attrs: {
      "position": "bottom",
      "close-on-click-overlay": false
    },
    on: {
      "click-overlay": _vm.onClose
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "address-list-select"
  }, [_c('div', {
    staticClass: "address-add-item",
    on: {
      "click": _vm.addressAdd
    }
  }, [_vm._v("新增发票抬头")]), _vm._v(" "), _c('van-cell-group', _vm._l((_vm.list), function(address) {
    return _c('van-cell', {
      key: address.id,
      attrs: {
        "center": "",
        "title": address.taitou + ' ' + address.shuihao,
        "is-link": ""
      },
      on: {
        "click": function($event) {
          return _vm.onSelect(address)
        }
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('van-popup', {
    style: ({
      height: '70%'
    }),
    attrs: {
      "position": "bottom"
    },
    on: {
      "click-overlay": _vm.onClose
    },
    model: {
      value: (_vm.showAdd),
      callback: function($$v) {
        _vm.showAdd = $$v
      },
      expression: "showAdd"
    }
  }, [_c('div', {
    staticClass: "address-form"
  }, [_c('van-cell-group', [_c('van-field', {
    attrs: {
      "input-align": "right",
      "label": "发票抬头",
      "error": _vm.formValidate && !_vm.formData.taitou,
      "placeholder": "请输入发票抬头"
    },
    model: {
      value: (_vm.formData.taitou),
      callback: function($$v) {
        _vm.$set(_vm.formData, "taitou", $$v)
      },
      expression: "formData.taitou"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "input-align": "right",
      "label": "税号",
      "error": _vm.formValidate && !_vm.formData.shuihao,
      "placeholder": "请输入税号"
    },
    model: {
      value: (_vm.formData.shuihao),
      callback: function($$v) {
        _vm.$set(_vm.formData, "shuihao", $$v)
      },
      expression: "formData.shuihao"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "input-align": "right",
      "label": "开户行及账号",
      "error": _vm.formValidate && !_vm.formData.account,
      "placeholder": "请输入开户行及账号"
    },
    model: {
      value: (_vm.formData.account),
      callback: function($$v) {
        _vm.$set(_vm.formData, "account", $$v)
      },
      expression: "formData.account"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "input-align": "right",
      "label": "购买方地址",
      "error": _vm.formValidate && !_vm.formData.address,
      "placeholder": "请输入购买方地址"
    },
    model: {
      value: (_vm.formData.address),
      callback: function($$v) {
        _vm.$set(_vm.formData, "address", $$v)
      },
      expression: "formData.address"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "input-align": "right",
      "label": "购买方电话",
      "error": _vm.formValidate && !_vm.formData.phone,
      "placeholder": "请输入购买方电话"
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px",
      "text-align": "center"
    }
  }, [_c('van-button', {
    staticStyle: {
      "height": "46px",
      "margin": "0 0 10px 0"
    },
    attrs: {
      "round": "",
      "size": "large"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onScan($event)
      }
    }
  }, [_vm._v("扫码导入（微信发票抬头）")]), _vm._v(" "), _c('van-button', {
    attrs: {
      "type": "danger",
      "round": "",
      "size": "large"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.formSave($event)
      }
    }
  }, [_vm._v("保存")])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f613694","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FapiaoPicker.vue
// module id = 2342
// module chunks = 0